import { alpha, palette } from '@/styles/shared';
export const audioProgressBarStyles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    opacity: 1,
    transition: 'opacity 0.3s ease',
  },
  progressBar: {
    position: 'relative',
    width: 308,
    height: 8,
    backgroundColor: 'rgba(249, 249, 249, 1)',
    borderRadius: '5px',
    boxShadow: '0px 0px 10px 0px rgba(0, 0, 0, 0.2)',
    mb: 1,
    overflow: 'hidden',
  },
  audioDurationBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    backgroundColor: alpha.purple100,
    borderRadius: '5px 0 0 5px',
  },
  playbackPositionBar: {
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    backgroundColor: alpha.purpleLight40,
    borderRadius: '5px 0 0 5px',
    transition: 'width 0.1s ease',
  },
  timeText: {
    color: palette.mutedText,
    fontSize: '12px',
    mb: 2,
  },
};
